const actionTypeIdentifier = "C276945F-464E-4EC9-B45D-420EFB1D523B";

export const getCircuitPIPInformationDetails = `GET-CIRCUIT-PIP-INFORMATION-DETAILS-${actionTypeIdentifier}`;
export const getOrderCircuitPIPInformationDetails = `GET-ORDER-CIRCUIT-PIP-INFORMATION-DETAILS-${actionTypeIdentifier}`;
export const getPIPPortSpeed = `GET-PIP-PORT-SPEED-${actionTypeIdentifier}`;
export const getPIPCarrierQosProfile = `GET-PIP-CARRIER-QOS-PROFILE-${actionTypeIdentifier}`;
export const getPIPVpnName = `GET-PIP-VPN-NAME-${actionTypeIdentifier}`;
export const getPIPVoiceCarSpeed = `GET-PIP-VOICE-CAR-SPEED-${actionTypeIdentifier}`;
export const getPIPVoiceCar = `GET-PIP-VOICE-CAR--${actionTypeIdentifier}`;
export const getPIPSiteOfOrigin = `GET-PIP-SITE--OF-ORIGIN-${actionTypeIdentifier}`;
export const setPortSpeedLoading = `SET-PORT-SPEED-LOADING-${actionTypeIdentifier}`;
export const setCarrierQosProfileLoading = `SET-CARRIER-QOS-PROFILE-LOADING-${actionTypeIdentifier}`;
export const setVpnNameLoading = `SET-VPN-NAME-LOADING-${actionTypeIdentifier}`;
export const setVoiceCarSpeedLoading = `SET-VOICE-CARRIER-SPEED-LOADING-${actionTypeIdentifier}`;
export const setVoiceCarLoading = `SET-VOICE-CARRIER-LOADING-${actionTypeIdentifier}`;
export const setSiteOfOriginLoading = `SET-SITE-OF-ORIGIN-LOADING-${actionTypeIdentifier}`;

export const pipInformationFormModel = {
    portSpeed: null,
    carrierQOSProfile: null,
    asnNumber: null,
    voiceCAR: null,
    routingProtocol: null,
    vpnName: null,
    voiceCARSpeed: null,
    asnNewOrExisting: null,
    siteOfOrigin: null,
};